import React from 'react'

interface DemoControlsToggleProps {
  active: boolean
  activeLabel: string
  inactiveLabel: string
  onToggle: () => void | Promise<void>
}

export const DemoControlsToggle = ({
  active,
  activeLabel,
  inactiveLabel,
  onToggle,
}: DemoControlsToggleProps) => {
  return (
    <button className='admin-button' onClick={() => { void onToggle() }}>
      {active ? activeLabel : inactiveLabel}
    </button>
  )
}
